const displayName = 'StudentsDropdown';
const placeholder = 'Select a student';

export { displayName, placeholder };
